<mat-card class="daxa-card profile-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <h5 class="mt-0 mb-0">
                Informations Complémentaires
            </h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <ul class="info-list pr-0 pl-0 mb-0 mt-0 list-unstyled">
            <li>
                <span class="text-body">Téléphone:</span> {{ user.phone || 'N/A' }}
            </li>
            <li>
                <span class="text-body">Adresse:</span>  {{ user.address || 'N/A' }}
            </li>
            <!--
            <li>
                <span class="text-body">Orders:</span> 696
            </li>
            <li>
                <span class="text-body">Products:</span> 9240
            </li>
            <li>
                <span class="text-body">Events:</span> 5
            </li>
            -->
        </ul>
    </mat-card-content>
</mat-card>